import { ProjectPhaseWithToolkitItems } from '../../project/types';
import { ToolkitItemsGrid } from './toolkit-items-grid';
import { ProjectPhasesDiagram } from './project-phases-diagram';

type ProjectPhasesProps = {
  projectPhases: ProjectPhaseWithToolkitItems[];
};

export function ProjectPhases({ projectPhases }: ProjectPhasesProps) {
  return (
    <>
      <ProjectPhasesDiagram projectPhases={projectPhases} />
      {projectPhases.map((projectPhase, projectPhaseIndex) => (
        <ToolkitItemsGrid
          key={projectPhase.title}
          projectPhase={projectPhase}
          imagePosition={(() => {
            switch (projectPhaseIndex) {
              case 1:
                return 'bottom-left-lg';
              case 2:
                return 'top-right-sm';
              case 3:
                return 'top-left-sm';
              case 0:
              default:
                return 'top-left-sm';
            }
          })()}
        />
      ))}
    </>
  );
}
